import { directories, directory } from '@/configs/endpoints'
import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import { i18n } from '@/plugins/vue-i18n.js'

const store = 'directory'

export default {
  state: () => ({
    country: [],
    carcassType: [],
    certificationAgency: [],
    listMeasuringLaboratories: [],
    laboratoryBranchOffice: [],
    vehicleCategory: [],
    vehicleMark: [],
    vehicleMarkByParams: [],
    vehicleModel: [],
    vehicleModelByParams: [],
    vehicleModificationByModel: [],
    vehicleCondition: [
      { id: 'Used', name: 'Був у користуванні' },
      { id: 'New', name: 'Новий' },
      { id: 'NewManual', name: 'Новий (внесення вручну)' }
    ],
    vehicleType: [],
    region: [],
    city: [],
    typeStreet: [],
    manufacturerCountry: [],
    engineManufacturer: [],
    legalActs: [],
    legalAct: [],
    coolingSystem: [],
    cylinderArrangement: [],
    euroRate: [],
    euroCodes: [],
    euroCode: [],
    engineLocation: [],
    pollutionReduction: [],
    workingPrinciple: [],
    vehicleDrive: [],
    steeringBoostMethod: [],
    steeringWheelLocation: [],
    transmissionType: [],
    vehicleColor: [],
    headlightType: [],
    wheelFormula: [],
    vehicleIdentificationMethod: [],
    vehicleIdentificationPlace: [],
    fuelType: [],
    windowType: [],
    cityByParams: [],
    trailerTypeBrakeConnector: [],
    organizationType: [],
    brakeControlType: [],
    brakeType: [],
    weather: [],
    seatPosition: [],
    beltCategory: [],
    laboratoryAgencyLists: [],
    certificationAgencyLists: [],
    headlightTypeLight: [{
      id: 1,
      name: 'C, CR'
    }, {
      id: 2,
      name: 'HC, HCR, DC, DCR'
    }],
    doorLocation: [],
    gasType: [{
      id: 1,
      name: 'Пропан'
    }, {
      id: 2,
      name: 'Метан'
    }, {
      id: 3,
      name: 'Не газ'
    }],
    inspectionTypesGas: [
      {
        name: i18n.t('vehicleCharacteristic.type_I_or_ESC'),
        value: 'type_I_or_ESC'
      },
      {
        name: i18n.t('vehicleCharacteristic.type_I_euro_5'),
        value: 'type_I_euro_5'
      },
      {
        name: i18n.t('vehicleCharacteristic.type_ETC'),
        value: 'type_ETC'
      }
    ],
    inspectionTypesSmoke: [
      {
        id: 0,
        name: i18n.t('vehicleCharacteristic.urbanCycle'),
      },
      {
        id: 1,
        name: i18n.t('vehicleCharacteristic.acceleratedUrbanCycle'),
      },
      {
        id: 2,
        name: i18n.t('vehicleCharacteristic.combinedCycle'),
      },
      {
        id: 3,
        name: i18n.t('vehicleCharacteristic.combinedAdjustedValue'),
      },
      {
        id: 4,
        name: i18n.t('vehicleCharacteristic.electricAndHybridVehicles'),
      }
    ],
    agency: [],
    laboratory: []
  }),
  actions: {
    getDirectories (context) {
      for (const directory of directories) {
        api.get(directory.endpoint).then(response => {
          if (requestValidation(response)) {
            const data = Array.isArray(response.data) && response.data.filter(i => i.is_active || i.is_active === undefined)
            context.commit('SET_DATA', { store, state: directory.state, data: data })
          }
        })
      }
    },
    async getDirectoryByEndpoint (context, data) {
      const response = await api.get(`${ directory[data.endpoint] }`)
      if (await requestValidation(response)) {
        let result = []
        if (Array.isArray(response.data) || Array.isArray(response.data.results)) {
          if (response.data.length) result = response.data.filter(i => i.is_active || i.is_active === undefined)
          if (response.data.results) result = response.data.results.filter(i => i.is_active || i.is_active === undefined)
        }
        context.commit('SET_DATA', { store, state: data.state || data.endpoint, data: result })
        return response.data
      }
    },
    async getDirectoryByParams (context, data) {
      const response = await api.get(`${ directory[data.endpoint](data.id || data.params) }`)
      if (await requestValidation(response)) {
        let result = []
        if (Array.isArray(response.data) || Array.isArray(response.data.results)) {
          if (response.data.length) result = response.data.filter(i => i.is_active || i.is_active === undefined)
          if (response.data.results) result = response.data.results.filter(i => i.is_active || i.is_active === undefined)
        }
        context.commit('SET_DATA', { store, state: data.endpoint, data: result })
        return response.data
      }
    },
    async getDirectoryById (context, data) {
      const response = await api.get(`${ directory[data.endpoint](data.id) }`)
      if (await requestValidation(response)) {
        context.commit('ADD_DATA', { store, state: data.state || data.endpoint, data: response.data })
        return response.data
      }
    }
  },
  getters: {
    directoryById: state => (directory, id) => state[directory].find(item => {
      return Number(item.id) === Number(id)
    }) || {}
  }
}
